import {UserAlertsError} from './UserAlertsError.js'

export class GetUserAlertError extends UserAlertsError {}
